import { render } from "./StudentTable.vue?vue&type=template&id=201bb9fa"
import script from "./StudentTable.vue?vue&type=script&lang=js"
export * from "./StudentTable.vue?vue&type=script&lang=js"

import "./StudentTable.vue?vue&type=style&index=0&id=201bb9fa&lang=css"
script.render = render

export default script